import * as kea from "kea-react";
import * as React from "react";
import * as models from "app/models/requireme";
import { resources } from "app/main/std";
import { observeResource } from "kea-resource";
import { Multiselector } from "app/features/componentes/multiselector";
import { columnasFijasRep } from "app/features/general/operativa/items/cobranza/reps/columns";
import { FiltroREPComponent } from "app/features/general/operativa/items/cobranza/reps/filtro";
import { createSelector, createSelectorRx } from "keautils";

interface Props {
    /**Ids de los reps sustituidos */
    value: number[];
    onChange: (x: number[]) => void;
}

interface State {
    filtro: models.FiltroRep;
}

export class RepsSustituidos extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { filtro: {} };
    }
    filtroSt = (state: State) => state.filtro;
    filtro = createSelector(this.filtroSt, x => ({
        ... x,
        EsCancelada : true,
        EsTimbrada: true
    }));

    items = createSelectorRx(this.filtro, filtro => observeResource(resources.Rep.Query, filtro));
    render() {
        return (
            <div>
                <FiltroREPComponent
                    value={this.state.filtro}
                    onChange={x => this.setState({ filtro: x })}
                />

                <Multiselector
                    hideBusqueda
                    items={this.items(this.state)}
                    columnas={columnasFijasRep}
                    getKey={x => x.IdRegistro}
                    value={this.props.value}
                    onChange={this.props.onChange}
                />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/componentes/facturas/pagos/form/sustituidos.tsx